export default {"src":"/_next/static/media/target.26836bdc.svg","height":70,"width":70,"blurWidth":0,"blurHeight":0};